var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.275,
    height: 86.666,
    viewBox: "0 0 87.275 86.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M-310.371,252.492v-5.444h1.1q14.927,0,29.855,0A11.1,11.1,0,0,1-267.9,258.592q0,25.3,0,50.6a11.025,11.025,0,0,1-8.9,11.028,12.473,12.473,0,0,1-2.6.239q-25.445.02-50.89.006c-5.519,0-9.859-3.259-11.156-8.375a11.456,11.456,0,0,1-.331-2.772q-.032-18.659-.014-37.319c0-.224.021-.447.037-.751h5.4v1.142q0,18.272,0,36.544c0,3.728,2.287,6.05,6.024,6.052q25.493.015,50.987,0a5.638,5.638,0,0,0,6-6.007q.008-25.2,0-50.4c0-3.715-2.4-6.077-6.151-6.079q-14.831-.006-29.661,0Z",
    transform: "translate(355.173 -233.804)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M-237.214,335.142c1.9,1.421,3.884,2.664,5.579,4.22a21.524,21.524,0,0,1,6.969,12.53,7.916,7.916,0,0,1-7.2,8.876c-5.132.153-10.271.089-15.407.093-5.233,0-10.47.093-15.7-.071a7.972,7.972,0,0,1-7.367-10.366,23.462,23.462,0,0,1,11.986-14.84,2.584,2.584,0,0,0,.253-.139.884.884,0,0,0,.133-.141,13.65,13.65,0,0,1,1.789-19.225,13.727,13.727,0,0,1,17.372.248A13.62,13.62,0,0,1-237.214,335.142Zm-10.486,20.24q7.365,0,14.73,0a2.647,2.647,0,0,0,2.766-3.593,18.277,18.277,0,0,0-4.33-7.675,18.322,18.322,0,0,0-8.992-5.217,2.654,2.654,0,0,1-2.128-3.263,3.147,3.147,0,0,1,1.865-2.076,8,8,0,0,0,3.5-10.255,7.976,7.976,0,0,0-9.823-4.391,7.573,7.573,0,0,0-5.439,6.53,7.762,7.762,0,0,0,3.972,8.078,6.164,6.164,0,0,1,1.46,1.079c1.067,1.246.824,3.708-2.06,4.482-6.571,1.761-10.72,6.093-12.857,12.5a2.846,2.846,0,0,0,2.9,3.849C-257.328,355.292-252.513,355.383-247.7,355.383Z",
    transform: "translate(297.841 -287.052)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M-397.417,197.578c-3.547,0-6.938.009-10.328,0a2.774,2.774,0,0,1-3.033-2.489,2.658,2.658,0,0,1,2.9-2.973c3.069-.035,6.139-.01,9.209-.011h1.255v-1.153q0-4.411,0-8.821c0-2.2.931-3.37,2.69-3.376,1.735-.006,2.755,1.233,2.756,3.351q0,4.411,0,8.821V192.1h1.209c3.167.006,6.333,0,9.5.024a2.558,2.558,0,0,1,2.422,1.637,2.561,2.561,0,0,1-.424,2.811,3,3,0,0,1-2.514,1.006q-4.507-.005-9.015,0h-1.178v1.1c0,3.134.015,6.269-.008,9.4a2.729,2.729,0,0,1-2.408,2.823,2.66,2.66,0,0,1-2.873-1.8,4.411,4.411,0,0,1-.152-1.332c-.012-3-.006-6.01-.006-9.015Z",
    transform: "translate(410.788 -178.749)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhotoIcon);
export default __webpack_public_path__ + "static/media/AddPhotoIcon.f8f53bf83c7abd2da81ea4a93b40841a.svg";
export { ForwardRef as ReactComponent };